<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
  export default {
    name:'app',
    created(){
      this.getConfig();
    },
    watch:{
      '$route':'changeRouter'
    },
    methods:{
      async getConfig(){
        let res = await this.$unifiedApi({
          api:this.$api.customConfig,
          fn:this.getConfig,
        });
        if (!res || !res.data) return;
        let data = res.data;
        if(data.respCode === '0000'){
          this.$store.dispatch('cashierConfigActions', data.obj).then(() => {});
          this.cashierConfig = data.obj;
          this.changeRouter();
        }
      },
      changeRouter(){
        let cashierConfig = this.cashierConfig;
        let globalTitle = cashierConfig.globalTitle || '聚合支付';
        if(this.$route.path=='/pay' || this.$route.path=='/anonymousPay' || this.$route.path=='/payResult'){
          document.title = cashierConfig.payTitle || globalTitle;
        }else if(!this.$route.meta.title){
          document.title = globalTitle;
        }
      },
    }
  }

</script>
<style lang="less">
  body, html {
    margin: 0;
    padding: 0;
    width:100%;
    height:100%;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width:100%;
    height:100%;
    /*background-color: #f2f2f2;*/
  }
  /*自定义样式*/
  .mt-5{margin-top:5px;}
  .mt-8{margin-top:8px;}
  .mt-10{margin-top:10px;}
  .mt-15{margin-top:15px;}
  .mt-16{margin-top:16px;}
  .mt-20{margin-top:20px;}
  .mt-50{margin-top:50px;}
  .mb-10{margin-bottom:10px;}
  .mb-15{margin-bottom:15px;}
  .mb-16{margin-bottom:16px;}
  .mb-20{margin-bottom:20px;}
  .mb-50{margin-bottom:50px;}
  .mr-10{margin-right:10px;}
  .mr-15{margin-right:15px;}
  .ml-10{margin-left:10px;}
  .ml-15{margin-left:15px;}
  .text-center{text-align: center;}
  .text-right{text-align: right;}
  .width-300{width:300px;}
  .btnBlock{width:100%;}
  .text-gray{color:#A3A3A3;}
  .text-success{color:#67c23a;}
  .text-danger{color:#f56c6c;}
  .text-warning{color:#ebb563;}
  .text-primary{color:#409eff;}
  //table
  .el-table td, .el-table th{
    padding:8px 0;
  }
  .el-table .cell{
    padding:0 10px;
  }
  .el-table thead tr th{
    background-color: #EDEDED;
  }
  /*footer始终保持在最底部 布局*/
  .hmfBox{
    height:100%;display: flex;flex-direction:column;
    .el-main{flex: 1 0 auto;}
  }
  //装饰banner
  .decorateBanner{
    height:60px;
    background:#ddd;
  }
  /*弹出层控制内容padding*/
  .el-dialog__header{
    padding:15px 15px 10px;
    border-bottom: 1px solid #dcdfe6;
  }
  .el-dialog__footer{
    padding:10px 15px;
  }
  .el-dialog__body{
    padding:15px;
  }
  /*ui样式修改*/
  .el-form-item--medium{
    margin-bottom:16px;
  }

  /*标签页padding*/
  .el-tabs--border-card>.el-tabs__content{
    padding:5px 10px;
  }
  /*导航样式*/
  .el-submenu .el-menu-item{
    min-width:150px;
    padding:0 0 0 30px !important;
  }
  /*面包屑*/
  .el-breadcrumb__item:last-child .el-breadcrumb__inner, .el-breadcrumb__item:last-child .el-breadcrumb__inner a, .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover, .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover{
    font-weight:600;
  }
  .el-breadcrumb__inner.is-link{
    font-weight:400;
  }
  /*flex*/
  .flex-box{
    display: flex;
  }
  .flex-center{
    justify-content: center;
  }
  .flex-between{
    justify-content: space-between;
  }
  .flex-around{
    justify-content: space-around;
  }
  .item-center{
    align-items: center;
  }

</style>
